import DateFnsUtils from "@date-io/date-fns";


export default class UaLocalizedUtils extends DateFnsUtils {
  //TODO
  /*getCalendarHeaderText(date) {
    return format(date, "LLLL", { locale: this.locale });
  }

  getDatePickerHeaderText(date) {
    return format(date, "dd MMMM", { locale: this.locale });
  }*/
}

